export const NOTIFY_SUBSCRIBE_FORM_ID = 'notify_bubble';
export const NOTIFY_WIDGET_POSITION = 'notify_bubble_shop_site';

export const NOTIFY_CONTENT_TYPE_IMG = 'image';
export const NOTIFY_CONTENT_TYPE_TXT = 'text';
export const NOTIFY_CONTENT_TYPE_MARKUP = 'markup';
export const NOTIFY_CONTENT_TYPE_WIDGET = 'widget';

/* subscribe notifier specific constants */
export const NOTIFY_TYPE_SUBSCRIBE = 'subscribe';

export const NOTIFY_SUBSCRIBE_TICKS_COUNT = 5;
export const NOTIFY_SUBSCRIBE_TICK_PERIOD = 30;
export const NOTIFY_SUBSCRIBE_STORAGE_KEY = 'notifySubscribeCounter';

/**
 * Constants for notify develop purposes
 * TODO: Remove when [SHOP-4691] is done
 */
export const NOTIFY_BASE_IMG_URL =
  'https://static.beeline.ru/upload/images/e-shop/popup/popup-image.png';
export const NOTIFY_BASE_WIDGET_DATA = {
  customSlug: 'subscribeForm',
  widgetData: {
    id: 'notifier_subscribe',
    backgroundUrl: null,
    initData: {
      isColumn: true,
      heading: 'Подпишитесь на нашу рассылку и первыми узнавайте о новинках и лучших ценах!',
      headingTagName: 'div',
      description: null,
      title: null,
      buttonText: 'Подписаться',
      markup: null,
      agreementTextTemplate: 'Я согласен с условиями обработки&nbsp;<AgreementTextLink>персональных данных</AgreementTextLink>&nbsp;', //eslint-disable-line
    },
    successData: {
      isColumn: true,
      heading: 'Готово!',
      headingTagName: 'div',
      description: 'Загляните, пожалуйста, в свой почтовый ящик и подтвердите подписку.',
      buttonText: 'Вперед за покупками',
      redirectUrl: 'https://beeline.ru/shop/catalog/telefony/smartfony/',
      openInNewTab: false,
      markup: null,
    },
  },
};
